import React, { useEffect, useState } from 'react';
import Footer from '../components/footer.tsx';
import Nav from '../components/nav.tsx';
import { about1img, about2img1, about2img2, about3imgMobile, about4img1, about4img2, about4img3, about4img3Mobile, about4img4, about4img5, about4img6, about4img7, about4logoInsurein } from '../configs/src_routes.ts';

const AboutPage = () => {

  const [imageLoaded, setImageLoaded] = useState<boolean>(false);

  useEffect(() => {
    const imageElement = document.getElementById('image') as HTMLImageElement | null;

    if (imageElement && imageElement.complete) {
      // 이미지가 이미 로드되어 있다면 이미지 로드 상태를 true로 설정
      setImageLoaded(true);
    } else if (imageElement) {
      // 이미지가 로드되지 않았다면 onLoad 이벤트를 추가하여 로드 완료 시 이미지 로드 상태를 true로 설정
      const handleImageLoad = () => {
        setImageLoaded(true);
      };
      imageElement.addEventListener('load', handleImageLoad);

      return () => {
        // 컴포넌트가 언마운트될 때 이벤트 리스너를 정리
        imageElement.removeEventListener('load', handleImageLoad);
      };
    }
  }, []);

  return (
    <div className='body-nav'>
      <div className={'loading-overlay'} style={{animationPlayState: (imageLoaded ? 'running' : 'paused')}}>
        <div className={'balls'}>
          <div />
          <div />
          <div />
        </div>     
      </div>
      <Nav />
      <section id='about1'>
        <div className='about1-script'>
          <h1>We provide financial services through high-tech.</h1>
          <p>We are always by your side, enriching your life with financial solutions that support and grow with you every step of the way.</p>
        </div>
        <img id='image' src={about1img} alt='wall street' />
      </section>
      <section id='about2'>
        <div className='about2-pad'>
          <h2>Finance</h2>
          <div className='about2-ct1'>
            <img src={about2img1} alt='graph' />
            <div className='about2-script1'>
              <h3>We connect customers with high-quality financial products.</h3>
              <p>By carefully selecting premium financial products, we ensure that customers access the best options tailored to their needs and goals.</p>
            </div>
          </div>
          <div className='about2-ct2'>
            <div className='about2-script2'>
              <h3>Reducing the information gap to ensure everyone has access to valuable financial resources.</h3>
              <p>We provide clear and accessible financial information, helping individuals make informed decisions and access the resources they need, regardless of their background or experience.</p>
            </div>
            <img src={about2img2} alt='man' />
          </div>
        </div>
      </section>
      <section id='about3'>
        <div className='about3-pad'>
          <div className='about3-wrap'>
            <div className='about3-ct-head'>
              <h2><span>AI Technology</span></h2>
              <p>We enhance the financial environment with AI technology, delivering the information customers need by quickly and accurately analyzing dense data.</p>
            </div>
            <div className='about3-divider' />
            <div className='about3-ct-body'>
              <div className='about3-ct1'>
                <h3>Simplifying financial tasks</h3>
                <p>By minimizing tasks that previously required excessive time and cost due to disorganized and overwhelming information, financial interactions are now streamlined through the most efficient methods.</p>
              </div>
              <div className='about3-ct2'>
                <h3>Profit simulation for different scenarios</h3>
                <p>The AI system derives projected outcomes by considering various factors, such as customer conditions, investment amount, and market situations.</p>
              </div>
            </div>
          </div>
          <img className='about3-img-mb' src={about3imgMobile} alt='golden wave' />
        </div>
      </section>
      <section id='about4'>
        <div className='about4-head'>
          <img src={about4logoInsurein} alt='insurein logo' />
          <div className='about4-ct'>
            <h2><span>insurein</span> makes<br/>people's future planning<br/>closer and easier</h2>
            <p>With Insurein, future planning is simple and accessible. Check your financial information anytime on mobile or PC and discover diverse financial products from across the globe.</p>
          </div>
          <button>Go Website</button>
        </div>
        <div className='about4-body'>
          <div className='about4-body-ct1'>
            <img src={about4img1} alt='finance products' />
            <img src={about4img2} alt='providing information' />
          </div>
          <div className='about4-body-ct2'>
            <img className='about4-img3' src={about4img3} alt='global service' />
            <img className='about4-img3-mb' src={about4img3Mobile} alt='global service' />
          </div>
          <div className='about4-body-ct3'>
            <img src={about4img4} alt='profitability simulation' />
            <img src={about4img5} alt='subscribe to financial products' />
            <img src={about4img6} alt='real-time subscription updates' />
            <img src={about4img7} alt='mobile & PC' />
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default AboutPage;